"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-unescaped-entities */
var bank = {
  id: "bank",
  title: {
    en: "Bank system",
    de: "Bank-System"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "# Keeping Items"), /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "L_Click the banker NPC then choose the 'my bank' menu to show extra space in the bank."), /*#__PURE__*/_react.default.createElement("li", null, "It is free to deposit items, but it costs money when withdraw items out of the bank."), /*#__PURE__*/_react.default.createElement("li", null, "The cost is 1\\/30 of the price of the item (when sold to NPCs)."), /*#__PURE__*/_react.default.createElement("li", null, "You can share your bank space with other characters using your account."))), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "# Money Exchange"), /*#__PURE__*/_react.default.createElement("p", null, "There are three denominations of currenty used in Ferentus: PP (Platinum), GP (Gold), and CP (Copper)."), /*#__PURE__*/_react.default.createElement("p", null, "You will notice that the coins in your inventory are unorganized. Visit the banker NPC and choose the exchange menu to organize your currency."), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        color: "#FCA610"
      }
    }, "1PP = 100GP, 1GP = 100CP EX) 40000CP = 400GP = 4PP"))
  }
};
var _default = bank;
exports.default = _default;